// contact_screen.js
import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";

import "../styles/contact_screen.css";

class ContactScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      company: "",
      job_title: "",
      inquiry_type: "",
      find_how: "",
      message: "",

      errorMessage: "", //
      isLoading: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errorMessage: "",
      successMessage: "",
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      first_name,
      last_name,
      email,
      phone,
      company,
      job_title,
      inquiry_type,
      find_how,
      message,
    } = this.state;

    if (
      !first_name.trim() ||
      !last_name.trim() ||
      !email.trim() ||
      !inquiry_type ||
      !message.trim()
    ) {
      this.setState({
        errorMessage:
          "Please fill in your name, email, inquiry type and message.",
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.setState({ errorMessage: "Please enter a valid email address." });
      return;
    }

    if (message.trim().length < 10) {
      this.setState({
        errorMessage: "Please write a little more in your message.",
      });
      return;
    }

    this.setState({ isLoading: true });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            first_name,
            last_name,
            email,
            phone,
            company,
            job_title,
            inquiry_type,
            find_how,
            message,
          }),
        },
      );

      const data = await response.json();

      if (data.success) {
        // SUCCESS — clear all fields and show green message
        this.setState({
          successMessage:
            "Thank you! Your message has been sent. We will be in touch shortly.",
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          company: "",
          job_title: "",
          inquiry_type: "",
          find_how: "",
          message: "",
        });
      } else {
        // BACKEND ERROR — Django returned success: false with a reason
        this.setState({ errorMessage: data.message });
      }
    } catch (error) {
      this.setState({
        errorMessage:
          "Could not reach the server. Please try again in a moment.",
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { isLoading, errorMessage, successMessage } = this.state;

    const { isLoggedIn } = this.props;

    return (
      <>
        <Header isLoggedIn={isLoggedIn} />

        {/* 1. CONTACT HERO BANNER  */}
        <section className="contact-hero py-5 text-white">
          <div className="container py-4">
            <h1 className="contact-hero-title mb-2">Get in Touch</h1>
            <p className="contact-hero-subtitle mb-0">
              Let's start a conversation that moves your business forward
            </p>
          </div>
        </section>

        {/* 2. CONTACT DETAILS & FORM */}
        <section className="py-5 bg-white">
          <div className="container py-lg-4">
            <div className="row g-5 align-items-start">
              {/* LEFT COLUMN — contact info and map (unchanged) */}
              <div className="col-12 col-lg-5">
                <span className="contact-badge mb-3">Contact information</span>
                <h2 className="contact-title mb-3">Book a Consultation</h2>
                <p
                  className="text-secondary mb-4"
                  style={{ fontSize: "16px", lineHeight: "1.6" }}
                >
                  Want to speak directly with a consultant? Schedule a call to
                  discuss your needs and goals.
                </p>

                {/* The Map */}
                <div className="map-container mb-4">
                  <iframe
                    title="XLP Office Location"
                    src="https://maps.google.com/maps?q=T-Hub%20Phase%202,%20Hyderabad&t=&z=14&ie=UTF8&iwloc=&output=embed"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                {/* Contact Methods */}
                <div className="d-flex flex-wrap gap-4 gap-md-5">
                  <div>
                    <h4
                      className="fw-medium text-dark mb-1"
                      style={{ fontSize: "16px" }}
                    >
                      Email
                    </h4>
                    <a
                      href="mailto:info@xlp.com"
                      className="text-secondary text-decoration-none"
                    >
                      info@xlp.com
                    </a>
                  </div>
                  <div>
                    <h4
                      className="fw-medium text-dark mb-1"
                      style={{ fontSize: "16px" }}
                    >
                      Office Address:
                    </h4>
                    <p className="text-secondary mb-0">T-hub 2.0</p>
                  </div>
                </div>
              </div>

              {/* RIGHT COLUMN — THE FORM */}
              <div className="col-12 col-lg-7">
                <div className="form-card bg-white rounded-4 p-4 p-md-5 shadow-sm border">
                  {/* Form Header */}
                  <div className="d-flex justify-content-between align-items-center bg-light rounded-3 p-3 px-4 mb-4">
                    <img
                      src="/assets/logos/xlp-logo.png"
                      alt="XLP Logo"
                      style={{ height: "30px", width: "auto" }}
                    />
                    <h3
                      className="fs-5 fw-medium mb-0"
                      style={{ color: "#b54a2e" }}
                    >
                      Send Us a Message
                    </h3>
                  </div>

                  {errorMessage && (
                    <div
                      className="alert alert-danger py-2 mb-4"
                      style={{ fontSize: "14px" }}
                      role="alert"
                    >
                      {errorMessage}
                    </div>
                  )}

                  {successMessage && (
                    <div
                      className="alert alert-success py-2 mb-4"
                      style={{ fontSize: "14px" }}
                      role="alert"
                    >
                      {successMessage}
                    </div>
                  )}

                  <form onSubmit={this.handleSubmit}>
                    <div className="row g-3 mb-3">
                      {/* FIRST NAME */}
                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="firstName"
                          className="form-label text-dark fw-medium small mb-1"
                        >
                          First Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="firstName"
                          name="first_name"
                          className="form-control xlp-input"
                          placeholder="First Name"
                          value={this.state.first_name}
                          onChange={this.handleChange}
                          disabled={isLoading}
                        />
                      </div>

                      {/* LAST NAME */}
                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="lastName"
                          className="form-label text-dark fw-medium small mb-1"
                        >
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="lastName"
                          name="last_name"
                          className="form-control xlp-input"
                          placeholder="Last Name"
                          value={this.state.last_name}
                          onChange={this.handleChange}
                          disabled={isLoading}
                        />
                      </div>
                    </div>

                    {/* EMAIL */}
                    <div className="mb-3">
                      <label
                        htmlFor="email"
                        className="form-label text-dark fw-medium small mb-1"
                      >
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control xlp-input"
                        placeholder="janeDoe@example.com"
                        value={this.state.email}
                        onChange={this.handleChange}
                        disabled={isLoading}
                      />
                    </div>

                    {/* PHONE — optional */}
                    <div className="mb-3">
                      <label
                        htmlFor="phone"
                        className="form-label text-dark fw-medium small mb-1"
                      >
                        Phone
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control xlp-input"
                        placeholder="+123 456 789"
                        value={this.state.phone}
                        onChange={this.handleChange}
                        disabled={isLoading}
                      />
                    </div>

                    {/* COMPANY & JOB TITLE — both optional, side by side */}
                    <div className="row g-3 mb-3">
                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="company"
                          className="form-label text-dark fw-medium small mb-1"
                        >
                          Company Name
                        </label>
                        <input
                          type="text"
                          id="company"
                          name="company"
                          className="form-control xlp-input"
                          placeholder="Company Name"
                          value={this.state.company}
                          onChange={this.handleChange}
                          disabled={isLoading}
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="jobTitle"
                          className="form-label text-dark fw-medium small mb-1"
                        >
                          Job Title
                        </label>
                        <input
                          type="text"
                          id="jobTitle"
                          name="job_title"
                          className="form-control xlp-input"
                          placeholder="Job Title"
                          value={this.state.job_title}
                          onChange={this.handleChange}
                          disabled={isLoading}
                        />
                      </div>
                    </div>

                    {/* DROPDOWNS — side by side
                        inquiry_type is mandatory (has *)
                        find_how is optional (no *) */}
                    <div className="row g-3 mb-3">
                      {/* INQUIRY TYPE — mandatory */}
                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="inquiryType"
                          className="form-label text-dark fw-medium small mb-1"
                        >
                          What are you interested in?{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <select
                          id="inquiryType"
                          name="inquiry_type"
                          className="form-select xlp-input"
                          value={this.state.inquiry_type}
                          onChange={this.handleChange}
                          disabled={isLoading}
                        >
                          <option value="">Select an option</option>
                          <option value="schools">
                            Schools & Institutions
                          </option>
                          <option value="students">Individual Learning</option>
                          <option value="channel">Channel Partnership</option>
                          <option value="workshops">XLP Workshops</option>
                          <option value="products">Robotics Products</option>
                          <option value="support">Support</option>
                          <option value="general">General Inquiry</option>
                          <option value="other">Other</option>
                        </select>
                      </div>

                      {/* HOW DID YOU FIND US — optional */}
                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="findHow"
                          className="form-label text-dark fw-medium small mb-1"
                        >
                          How did you find us?
                        </label>
                        <select
                          id="findHow"
                          name="find_how"
                          className="form-select xlp-input"
                          value={this.state.find_how}
                          onChange={this.handleChange}
                          disabled={isLoading}
                        >
                          <option value="">Select an option</option>
                          <option value="youtube">YouTube</option>
                          <option value="instagram">Instagram</option>
                          <option value="search-engine">
                            Google / Search Engine
                          </option>
                          <option value="referral">Friend or Referral</option>
                          <option value="institution">School or College</option>
                          <option value="workshop-event">
                            Workshop or Event
                          </option>
                          <option value="whatsapp">WhatsApp</option>
                          <option value="social-media">Social Media</option>
                          <option value="other">Other</option>
                        </select>
                      </div>
                    </div>

                    {/* MESSAGE */}
                    <div className="mb-4">
                      <label
                        htmlFor="message"
                        className="form-label text-dark fw-medium small mb-1"
                      >
                        Message <span className="text-danger">*</span>
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        rows="4"
                        className="form-control xlp-input"
                        placeholder="To better assist you, please describe how we can help ;)"
                        value={this.state.message}
                        onChange={this.handleChange}
                        disabled={isLoading}
                      ></textarea>
                    </div>

                    {/* SUBMIT BUTTON
                        - Text switches to "Sending..." while waiting
                        - Disabled while loading to prevent double submissions */}
                    <button
                      type="submit"
                      className="btn submit-btn w-100 py-3 mb-4"
                      disabled={isLoading}
                    >
                      {isLoading ? "Sending..." : "Submit"}
                    </button>

                    <p className="form-disclaimer mb-0">
                      By submitting this form you agree to our Privacy Policy.
                      XLP may contact you via email or phone for scheduling or
                      marketing purposes.
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

export default ContactScreen;
